import { Row, Typography } from 'antd'
import Markdown from 'react-markdown'
import styled from 'styled-components'
import { InputDiagnosis } from './InputDiagnosis'
import { BaseQuestionProps } from '../types'
import QuestionContainer from '../QuestionContainer'

const { Text } = Typography

export type PrimaryDiagnosesQuestionProps = Omit<BaseQuestionProps, 'layout'>

function PrimaryDiagnosesQuestion({
  field,
  formFieldName,
  required
}: PrimaryDiagnosesQuestionProps): JSX.Element {
  const { text: primaryText, extension } = field
  const secondaryText = extension?.[0]?.valueCodeableConcept?.coding?.[0]?.display

  return (
    <QuestionContainer linkId={field.linkId}>
      <Container>
        <InputDiagnosisContainer>
          <Row align="middle">
            <Text strong>{primaryText}</Text>
          </Row>
          <Row>
            <Text type="secondary" style={{ display: 'block' }}>
              <Markdown>{secondaryText}</Markdown>
            </Text>
          </Row>
          <Row style={{ gap: '16px' }}>
            <InputDiagnosis fieldName={formFieldName} label={PRIMARY_LABEL} required={required} />
          </Row>
        </InputDiagnosisContainer>
      </Container>
    </QuestionContainer>
  )
}

const PRIMARY_LABEL = 'Primary Diagnosis'

const Container = styled.div`
  margin: 16px 0;
`

const InputDiagnosisContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export default PrimaryDiagnosesQuestion
